import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Checkout from "../components/Checkout";
import ScrollToTop from "react-scroll-to-top";
import NewsletterTwo from "../components/NewsletterTwo";


const CheckoutPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="var(--brand-primary)" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderThree */}
      <HeaderThree/>

      {/* Breadcrumb */}
      <Breadcrumb title={"Checkout"} />

      {/* Checkout */}
      <Checkout />

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* Footer */}
      <Footer />

    </>
  );
};

export default CheckoutPage;